
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-categories",
      function () {
        return require("private-next-pages/all-categories/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-categories"])
      });
    }
  